// extracted by mini-css-extract-plugin
export default {"svg":"UpArrowSvg_svg__oGVch"};